module.exports = __webpack_public_path__ + "static/img/3.c03d4351.png";